import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Comment, NotificationTypeEnum } from '@core/interfaces';
import { Observable, Subject } from 'rxjs';
import io from 'socket.io-client';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private readonly socket: any;

  public readonly realtimeNotification$ = new Subject<Record<string, any>>();

  constructor(private readonly authenticationService: AuthenticationService) {
    this.socket = io(environment.REALTIME_URL, { autoConnect: false });

    this.socket.on('reconnect_attempt', () => this.updateToken());
    this.socket.on('connect', () => console.warn('connect done'));
    this.socket.on('disconnect', () => console.warn('disconnect done'));

    this.socket.on('enterprise-notification', ({ message }) => {
      this.realtimeNotification$.next(message);
    });
  }

  public get lastNotificationObs(): Observable<Record<string, any>> {
    return this.realtimeNotification$.asObservable();
  }

  public disconnect(): void {
    this.socket.disconnect();
  }

  public connect(): void {
    this.updateToken();
    this.socket.connect();
  }

  public async reconnect(): Promise<void> {
    this.disconnect();
    this.connect();
  }

  private get token(): string {
    return this.authenticationService.accessToken || '';
  }

  private updateToken(): void {
    this.socket.io.opts.query = {
      token: this.token
    };
  }
}
